import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as IconClose } from "../../../build/images/closecircle22px.svg";
import { ReactComponent as CleanIcon } from "../../../build/images/icons/Clean.svg";
import { ReactComponent as CalendarIcon } from "../../../build/images/calendar.svg";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import QueueNew from "../../../containers/QueueNew/QueueNewV2";

import "./drawer-slim.css";
import Typography from "../../Typography";

export default function Main({
  title = "Drawer Title",
  className = "",
  isOpen,
  typeScreen = "",
}) {
  const drawerRef = useRef();

  return (
    <div
      className={`drawer-slim ${
        isOpen ? "drawer-slim-visible" : ""
      } ${className}`}
    >
      <div
        className={`drawer-slim-div ${
          isOpen ? "drawer-slim-div-visible queue" : ""
        } `}
        ref={drawerRef}
      >
        <div className="drawer__div__content">
          {isOpen ? (
            <QueueNew exhibDrawer={isOpen} typeScreen={typeScreen} />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
